// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1ZR8F","box":"WorkspacesBox_box__NtRhi","node":"WorkspacesBox_node__1NVYG"};